import { Ref, ref } from '@vue/composition-api';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { getCurrentUserEvents } from '@front-app/services/EventsApi/EventsApi';
import { getGlobalContext } from '@front-app/util/env';

export interface EventsStore {
	getEventsOnce(): Promise<void>;
	getEvents(): Promise<void>;
	eventById(id: string): EventV2 | undefined;
	events: Ref<EventV2[]>;
}

/* Prevent refetching events until 5 minutes has passed */
const TIMEOUT = 1000 * 60 * 5;

export const getEventsStore = (): EventsStore => {
	let pend: Promise<void> = Promise.resolve();
	let tid: undefined | number;
	let hasFetched = false;
	const events = ref([]) as Ref<EventV2[]>;

	const getEvents = () => {
		pend = Promise.resolve();
		getGlobalContext().clearTimeout(tid);
		tid = getGlobalContext().setTimeout(() => {
			hasFetched = false;
			pend = Promise.resolve();
		}, TIMEOUT);
		hasFetched = true;
		pend = getCurrentUserEvents()
			.then((userEvents) => {
				events.value = userEvents;
			})
			.catch(() => {
				hasFetched = false;
			});
		return pend;
	};

	const getEventsOnce = () => (hasFetched ? pend : getEvents());

	const eventById = (id: string) => events.value.find((event) => event.id === id);

	return {
		getEventsOnce,
		getEvents,
		eventById,
		events,
	};
};
